import React from 'react'
import { GridList, GridListTile, GridListTileBar, withStyles } from '@material-ui/core'
import { Redirect } from 'react-router-dom'

const styles = theme => ({
    root: {
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
    },
    gridList: {
        width: "100%"
    },
    tile: {
        cursor: 'pointer'
    },
    tileImage: {
        transition: 'all 0.5s',
        '&:hover': {
            height: '120%'
        }
    }
})

class ArticlesGridList extends React.Component {
    state = {
        redirectURL: null,
    }

    handleArticleClick = (id) => {
        this.setState({ redirectURL: `/article/${id}` })
    }

    returnRedirect = () => {
        if (this.state.redirectURL) {
            return (
                <Redirect to={`${this.state.redirectURL}`} />
            )
        }
    }

    render() {
        const { classes, articles } = this.props
        return(
            <div className={classes.root}>
                { this.returnRedirect() }
                <GridList cellHeight={420} className={classes.gridList} spacing={0} >
                    {articles && articles.map(a => (
                            <GridListTile
                                key={a.id}
                                className={classes.tile}
                                onClick={() => this.handleArticleClick(a.id)}
                                cols={a.first ? 2 : (2/3)}>
                                    <img className={classes.tileImage} src={a.imageURL} alt={a.title} />
                                <GridListTileBar style={{ textAlign: 'center' }} title={a.title} subtitle={a.authorName} />
                            </GridListTile>
                    ))}
                </GridList>
                    
            </div>
        )
    }
}

export default withStyles(styles)(ArticlesGridList)